<template>
  <div class="travel-with-confidence">
    <div class="travel-with-confidence__container">
      <div class="travel-with-confidence__title">
        {{t('Travel with Confidence')}}
      </div>
      <div class="travel-with-confidence__info">
        <p>{{t('Our accreditation and dedicated support team ensure that your journey is seamless and worry-free. Count on us for a trusted and professional service.')}}</p>
      </div>
      <div class="travel-with-confidence__list">
        <div class="travel-with-confidence__item">
          <img src="/images/a_1.svg" alt="ASTA - American Society of Travel Advisors">
        </div>
        <div class="travel-with-confidence__item">
          <img src="/images/a_2.svg" alt="IATA - International Air Transport Association">
        </div>
        <div class="travel-with-confidence__item">
          <img src="/images/a_3.svg" alt="CLIA - Cruise Lines International Association">
        </div>
        <div class="travel-with-confidence__item">
          <img src="/images/a_4.svg" alt="NTA - National Tour Association">
        </div>
      </div>
      <!-- Live chat button disabled for now — use the /support contact form. Remove v-if="false" to re-enable. -->
      <div class="flex justify-center" v-if="false">
        <button class="btn btn-primary open-live-chat" @click="openLiveChat">
          <img src="/icons/chat.svg" alt="" role="presentation" aria-hidden="true">
          {{t('Open LiveChat')}}
        </button>
      </div>
    </div>
  </div>
</template>

<script lang="ts" setup>
const liveChat = useLiveChat()
const { t } = useI18n()
const openLiveChat = () => {
  liveChat.showLiveChat()
}
</script>
<style lang="scss">
.travel-with-confidence {
  background: var(--light-grey);
  border-top: 1px solid var(--grey-border);
  border-bottom: 1px solid var(--grey-border);
  padding: 40px 0;

  @media screen and (max-width: 1252px) {
    padding: 40px 16px;
  }

  &__title {
    font-weight: 600;
    font-size: 34px;
    line-height: 44px;
    letter-spacing: 0;
    margin-bottom: 14px;
  }

  &__info {
    p {
      font-weight: 400;
      font-size: 22px;
      line-height: 28px;
      letter-spacing: 0;

      @media screen and (max-width: 768px) {
        font-size: 16px;
        line-height: 24px;
      }
    }
  }

  &__container {
    width: 100%;
    max-width: 1120px;
    margin: 0 auto;
  }

  &__list {
    display: flex;
    justify-content: space-between;
    gap: 12px;
    margin: 40px 0;

    @media screen and (max-width: 768px) {
      flex-wrap: wrap;
      justify-content: flex-start;
    }
  }

  &__item {
    img  {
      width: 100%;
    }

    &:nth-child(1) {
      img {
        @media screen and (max-width: 768px) {
          width: auto;
          height: 53px;
        }
      }
    }
    &:nth-child(2) {
      img {
        @media screen and (max-width: 768px) {
          width: auto;
          height: 53px;
        }
      }
    }
    &:nth-child(3) {
      img {
        @media screen and (max-width: 768px) {
          width: auto;
          height: 60px;
        }
      }
    }
    &:nth-child(4) {
      @media screen and (max-width: 768px) {
        img {
          @media screen and (max-width: 768px) {
            width: auto;
            height: 60px;
          }
        }
      }
    }
  }

  &__item img {
    :root[data-theme="dark"] & {
      background: #fff;
      padding: 6px 10px;
      border-radius: 8px;
    }
  }

  .btn.open-live-chat {
    display: flex;
    align-items: center;
    border-radius: 6px;
    background: var(--blue);

    &:hover {
      background: var(--dark-blue);
    }
  }
}
</style>
